import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import imgUser from "../../assets/img/home.png"; // Cambia por la imagen correcta

const skills = [
  { name: "Communication", percentage: 97 },
  { name: "Organization", percentage: 88 },
  { name: "Attention to detail", percentage: 92 },
  { name: "Empathy", percentage: 95 },
  { name: "Problem Solving", percentage: 100 },
  { name: "Adaptability", percentage: 95 },
  { name: "Time Management", percentage: 95 },
];

const AnimatedProgressBar = ({ name, percentage }) => {
  const { ref, inView } = useInView({ threshold: 0.2 });
  const [hasAnimated, setHasAnimated] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
      let start = 0;
      const increment = percentage / 50; 
      const interval = setInterval(() => {
        start += increment;
        if (start >= percentage) {
          start = percentage;
          clearInterval(interval);
        }
        setCount(Math.floor(start));
      }, 20);
    }
  }, [inView, hasAnimated, percentage]);

  return (
    <div className="mb-4" ref={ref}>
      <div className="flex justify-between items-center">
        <p className="text-gray-700 font-medium">{name}</p>
        <motion.span
          initial={{ opacity: 0, y: -10 }}
          animate={hasAnimated ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-gray-700 font-bold"
        >
          {count}%
        </motion.span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={hasAnimated ? { width: `${percentage}%` } : {}}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="h-full bg-red-400 rounded-full"
        />
      </div>
    </div>
  );
};

const SkillsSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Imagen */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex justify-center"
        >
          <img
            src={imgUser}
            alt="User Profile"
            className="w-40 h-40 rounded-full border-4 border-red-400 shadow-lg"
          />
          <div></div>
        </motion.div>

        {/* Habilidades */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        >
          <h3 className="text-2xl font-bold text-gray-800 mb-4">Soft Skills</h3>
          {skills.map((skill, index) => (
            <AnimatedProgressBar key={index} name={skill.name} percentage={skill.percentage} />
          ))}

          {/* Descripción final */}
          <p className="mt-6 text-gray-700 leading-relaxed">
            Candidates are selected for their professional experience and technical skills, 
            as well as soft skills like communication, empathy, and adaptability.
          </p>
          <p className="mt-2 text-gray-700 leading-relaxed">
            Once selected, candidates receive training through Your Virtual  University before being 
            placed with a client as a full-time Your Virtual  Representative.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SkillsSection;
